import { createStyles, Theme } from '@material-ui/core/styles';

import { BREAKPOINT } from '@Clinic/core/Layout/Layout.constants';

export default function styles({ breakpoints }: Theme) {
  return createStyles({
    root: {},

    [breakpoints.down(BREAKPOINT.mobile)]: {
      root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        height: '100%',
      },
    },
  });
}
